import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { IconLink, IconNotebook, IconFileCheck } from '@tabler/icons-react';
import InfoUnavailable from '../../../../../components/common/InfoUnavailable';

function PlanIdNetwork({ commercialPlanInfo }) {
  const { links } = commercialPlanInfo?.contact_and_links ?? {};
  const linkData = [
    {
      url: links?.plan_brochure_url?.trim(),
      label: 'Plan Brochure',
      icon: <IconNotebook size={18} />,
    },
    {
      url: links?.summary_of_benefits_url?.trim(),
      label: 'Summary of Benefits',
      icon: <IconFileCheck size={18} />,
    },
    // {
    //   url: links?.network_url?.trim(),
    //   label: 'Network',
    //   icon: <IconLink size={18} />,
    // },
  ].filter((link) => link.url);

  return (
    <div
      className="tab-pane fade "
      id="pills-network-commercial"
      role="tabpanel"
      aria-labelledby="pills-network-tab"
      tabIndex={0}
    >
      <div>
        <h1 className="drug-name">Plan &amp; Network</h1>
        <div className="row">
          <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
            <label>Plan Marketing Name</label>
            <p>{commercialPlanInfo?.plan_details?.plan_marketing_name}</p>
          </div>
          <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
            <label>Plan Type</label>
            <p>{commercialPlanInfo?.plan_details?.plan_type}</p>
          </div>
          <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
            <label>Issuer Name</label>
            <p>{commercialPlanInfo?.plan_details?.issuer_name}</p>
          </div>
          <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
            <label>Metal Level</label>
            <p>{commercialPlanInfo?.plan_details?.metal_level}</p>
          </div>
          <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
            <label>State Code</label>
            <p>{commercialPlanInfo?.plan_details?.state_code}</p>
          </div>
          <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
            <label>County Name</label>
            <p>{commercialPlanInfo?.plan_details?.county_name}</p>
          </div>
          <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
            <label>Rating Area</label>
            <p>{commercialPlanInfo?.plan_details?.rating_area}</p>
          </div>
          <div className="col-xxl-3 col-lg-4 col-sm-6 col-12 drug-info">
            <label>Customer Service</label>
            <p>
              {
                commercialPlanInfo?.contact_and_links?.customer_service
                  ?.phone_number_local
              }
            </p>
          </div>
          <div className="col-12 drug-info">
            <label>Additional Resources</label>
            {linkData.length > 0 ? (
              linkData.map((link, index) => (
                <div key={index}>
                  <Link to={link.url} target="_blank">
                    {link.icon} {link.label}
                  </Link>
                </div>
              ))
            ) : (
              <InfoUnavailable />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

PlanIdNetwork.propTypes = {
  commercialPlanInfo: PropTypes.object.isRequired,
};

export default PlanIdNetwork;
